import { render, staticRenderFns } from "./Adicionales.vue?vue&type=template&id=7d71bca9&scoped=true&"
import script from "./Adicionales.vue?vue&type=script&lang=js&"
export * from "./Adicionales.vue?vue&type=script&lang=js&"
import style0 from "./Adicionales.vue?vue&type=style&index=0&id=7d71bca9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d71bca9",
  null
  
)

export default component.exports